// extracted by mini-css-extract-plugin
export default {"pillTab":"style_pillTab__v+DM5","pill":"style_pill__MzgmC"};